module.exports = __webpack_public_path__ + "img/reosc.900ecd94.svg";